<template>
    <v-col cols="12" sm="16" md="6">
        <v-card dark :style="`background: ${backColors}`">
            <div class="">
                <v-avatar class="" size="130" tile style="width: 100%">
                    <v-img :src="project.image"></v-img>
                </v-avatar>
                <div>
                    <v-card-title class="text-h6" style="color: black">{{ project.title }}</v-card-title>
                    <v-card-subtitle>{{ project.overview | truncate(160) }}</v-card-subtitle>
                    <v-dialog width="600">
                        <template v-slot:activator="{ on, attrs }">
                            <v-card-actions>
                                <v-chip class="ma-2" color="primary" text-color="white" outlined>
                                    <v-icon small class="mr-2">
                                        mdi-calendar-range
                                    </v-icon>
                                    {{ project.year }}
                                </v-chip>
                                <v-btn class="ml-2" outlined rounded small v-bind="attrs" v-on="on">
                                    <v-icon small class="mr-1">
                                        mdi-fire
                                    </v-icon>
                                    Read More
                                </v-btn>
                            </v-card-actions>
                        </template>

                        <v-card>
                            <v-card-title class="text-h5" :style="`background: ${backColors}`">
                                {{ project.title }}
                            </v-card-title>

                            <v-card-text>
                                {{ project.description }}
                            </v-card-text>
                            <v-divider></v-divider>
                            <v-spacer></v-spacer>
                            <v-chip class="mx-2 my-1" color="#311B92" text-color="#0FF" v-for="technology in project.technologies" :key="technology">
                                {{ technology }}
                            </v-chip>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
        </v-card>
    </v-col>
</template>

<script>
export default {
    props: ['project'],
    filters: {
        truncate: function(data,num){
            const reqdString = 
              data.split("").slice(0, num).join("");
            return reqdString + "...";
        }
    },
    computed: {
        backColors: function () {
            const colors = `linear-gradient(to left, ${this.project.colors[1]}, ${this.project.colors[0]})`
            return colors
        }
    }
}
</script>

<style scoped>
</style>